import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { isError } from "react-query";
import { APIError } from "src/types";
import { isAPIErrorList } from "src/utils/error.utils";
import { parseServerError } from "src/utils/string.utils";

interface Props {
  data: APIError[] | Error;
}

export function ServerErrors(props: Props) {
  const { data } = props;

  // render the component
  return render();

  function render() {
    if (isAPIErrorList(data)) return <APIErrors data={data} />;
    if (isError(data)) return renderError(data);
    else return null;
  }

  function renderError(error: Error) {
    return <Alert severity="error">{error.message}</Alert>;
  }
}

function APIErrors(props: { data: APIError[] }) {
  const { data } = props;
  const { t } = useTranslation();

  return render();

  function render() {
    return (
      <>
        {data.map((serverError, i) => {
          return (
            <Alert severity="error" key={serverError.key + i}>
              {renderAPIError(serverError)}
            </Alert>
          );
        })}
      </>
    );
  }

  function renderAPIError(error: APIError) {
    if (error.key === "invalid_credentials") return t("label.invalidCredentials");
    if (error.key === "password_too_short") return t("label.passwordsTooShort", { length: error.arguments[0] });
    if (error.key === "password_distinct_chars")
      return t("label.passwordsDistinctChars", { length: error.arguments[0] });
    else return parseServerError(error);
  }
}
